// extracted by mini-css-extract-plugin
module.exports = {"container":"Approval_container__8ynnR","cell":"Approval_cell__2nM6L","left":"Approval_left__2NLVk","right":"Approval_right__GDCvg"};